import React, {Component, PropTypes} from 'react'
import {Portal} from 'react-overlays'
import cx from 'classnames'

export class Modal extends Component {
  static propTypes = {
    className: PropTypes.string,
    show: PropTypes.bool,
    onHide: PropTypes.func,
    scrollable: PropTypes.bool,
    container: PropTypes.any,
    children: PropTypes.any,
  }

  static defaultProps = {
    className: '',
  }

  _mouseDown = false

  componentDidMount() {
    this._keyup = this.keyup.bind(this)
    if (this.props.show) {
      this.addKeyListener()
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.show && !this.props.show) {
      this.addKeyListener()
    } else if (!nextProps.show && this.props.show) {
      this.removeKeyListener()
    }
  }

  componentWillUnmount() {
    if (this.props.show) {
      this.removeKeyListener()
    }
  }

  addKeyListener() {
    window.addEventListener('keyup', this._keyup)
  }

  removeKeyListener() {
    window.removeEventListener('keyup', this._keyup)
  }

  keyup(e) {
    if (e.keyCode === 27 && this.props.show) {
      this.props.onHide()
    }
  }

  render() {
    if (!this.props.show) {
      return null
    }

    return (
      <Portal container={this.props.container}>
        <div
          ref={(r) => this._modal = r}
          className={cx('modal', this.props.className, { scrollable: this.props.scrollable })}
        >
          <div
            className="modal--close"
            onClick={this.props.onHide}
          >
            <i className="icon-x" />
          </div>
          <div className="modal--content"
            onMouseDown={(e) => { this._mouseDown = true; e.stopPropagation(); }}
            onMouseOut={() => { this._mouseDown = false; }}
            onMouseUp={(e) => { if (this._mouseDown) this.props.onHide(e); }}
          >
            <div className="modal--body">
              {this.renderContent()}
            </div>
          </div>
        </div>
      </Portal>
    )
  }

  renderContent() {
    return React.Children.map(this.props.children, (child) => child || false);
  }
}
